// extracted by mini-css-extract-plugin
export default {"cell":"ViewContactLogCell_cell__J9Sp7","btn":"ViewContactLogCell_btn__Mnljq"};